<template>
  <span>
    <b-button
      @click.prevent="$event.target.blur()"
      class="mr-1"
      :pressed.sync="buttonBarcodeScanner"
      :variant="variantBarcodeScanner"
    >
      {{ textBarcodeScanner }}
    </b-button>
  </span>
</template>

<script>
export default {
  name: "BarcodeScanner",
  data() {
    return {
      buttonBarcodeScanner: false,
      variantBarcodeScanner: "danger",
      textBarcodeScanner: "Barcode Off"
    };
  },
  watch: {
    buttonBarcodeScanner(value) {
      if (value) {
        this.$barcodeScanner.init(this.onBarcodeScanned);
        this.variantBarcodeScanner = "success";
        this.textBarcodeScanner = "Barcode On";
      } else {
        this.$barcodeScanner.destroy();
        this.variantBarcodeScanner = "danger";
        this.textBarcodeScanner = "Barcode Off";
      }
    }
  },
  methods: {
    onBarcodeScanned(barcode) {
      this.onScan(barcode);
    },
    onScan(e) {
      this.$emit("on-scan", e);
    }
  }
};
</script>

<style scoped></style>
